import script from "./CompanyNewsView.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyNewsView.vue?vue&type=script&setup=true&lang=js"

import "./CompanyNewsView.vue?vue&type=style&index=0&id=16437586&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16437586"]])

export default __exports__